
import Vue from 'vue';

import {Component} from 'vue-property-decorator';
import {deleteLog, getLogs} from '@pazion/pazion-core/src/services/auth-service';
import {LOG_LEVELS, COLOR_MAP, LOG_LEVEL_MAP, LogLevel} from "@pazion/pazion-core/src/models/log-models";
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import DataDialog from "@pazion/pazion-core/src/components/utils/DataDialog.vue";
import PazTextSearch from "@pazion/pazion-core/src/components/controls/PazTextSearch.vue";
import PazListFilterSelector from "@pazion/pazion-core/src/components/utils/PazListFilterSelector.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import {authentication} from "@pazion/pazion-core/src/store";

@Component({
  components: {
    PazTooltipButton,
    DataDialog,
    PazRefreshButton,
    PazTextSearch,
    PazListFilterSelector
  }
})
export default class LogsPage extends Vue {

  public extraInfo = {};
  public dialog = false;
  public logLevels: LogLevel[] = LOG_LEVELS;
  public loading: boolean = false;
  public autoupdate: boolean = false;
  public search: string = '';
  public items = [];
  public selectedLogLevels: [] = [];
  private MAX_MESSAGE_LENGTH: number = 150;

  public headers: object[] = [
    {
      text: 'id',
      align: 'right',
      sortable: true,
      value: 'id',
      class: 'nowrap',
      cellClass: 'nowrap',
    },
    {
      class: 'nowrap',
      cellClass: 'nowrap',
      text: 'date',
      align: 'right',
      sortable: true,
      value: 'timestamp',
    },
    {
      class: 'nowrap',
      text: 'log level',
      align: 'center',
      sortable: true,
      value: 'priority',
    },
    {
      text: 'message',
      align: 'left',
      sortable: true,
      value: 'message',
    },
    {
      class: 'nowrap',
      text: 'extra info',
      align: 'right',
      sortable: true,
      value: 'extra',
    },
  ];

  get isSystemUser(){
    return authentication.isSystem;
  }

  priorityColor(priorityLevel: number) {
    if (COLOR_MAP.hasOwnProperty(priorityLevel)) {
      return COLOR_MAP[priorityLevel];
    }
    return 'blue';
  }

  priorityName(priorityLevel: number) {
    if (LOG_LEVEL_MAP.hasOwnProperty(priorityLevel)) {
      return LOG_LEVEL_MAP[priorityLevel];
    }
    return priorityLevel;
  }

  isEmpty(item: any) {
    return item.message.length < this.MAX_MESSAGE_LENGTH && (item.extra.length == 0 || item.extra == '[]');

  }

  truncateMessage(msg: string): string {
    if (msg.length < this.MAX_MESSAGE_LENGTH) {
      return msg;
    }
    return msg.slice(0, this.MAX_MESSAGE_LENGTH - 2) + ' ..';
  }

  get filteredItems() {
    if (this.ietsGeselecteerd) {
      return this.doFilter(this.items);
    }
    return this.items;
  }

  doFilter(items: any[]) {
    const lvls = this.selectedLogLevels;
    return items.filter(function (item) {
      return lvls.includes(item.priority);
    });
  }

  created() {
  }

  public usettings:[] = [];

  getUserSettings(){
    let store = localStorage.getItem('logsettings');
    if(store != null){
        this.usettings = JSON.parse(store);
        return this.usettings;
    }
      LOG_LEVELS.forEach((level: LogLevel) =>{
        this.usettings.push(level.level);
      });
    return this.usettings;
  }
  saveUserSettings() {
    // localStorage.setItem('logsettings', JSON.stringify(this.usettings.sort()));
  }

  // @Watch("selectedLogLevels")
  // updateUserSettings(newvalue: []): void{
  //   this.usettings = newvalue;
  //   if(this.doneLoading){
  //     this.saveUserSettings();
  //   }
  // }
  private doneLoading:boolean = false;
  mounted(){
    // this.getUserSettings();
    // this.selectedLogLevels = this.usettings;
    this.fetchData();
    this.doneLoading=true;

  }

  async fetchData() {
    this.loading = true;
    this.items = await getLogs();
    this.loading = false;
  }

  private deleteDelayTimeOut:number=0;

  async deleteItem(item: any) {
    item.isDeleted=true;
    let rsp = await deleteLog(item.id);
    clearTimeout(this.deleteDelayTimeOut);
    item.isDeleted= rsp.id > 0;
    if(item.isDeleted){
      this.deleteDelayTimeOut = setTimeout(() =>{
        this.fetchData();
      }, 5000);
    }
  }
  showInfo(item: any) {
    this.extraInfo = item;
    this.dialog = true;
  }

  toggle() {
    this.$nextTick(() => {
      if (this.allesGeselecteerd) {
        this.selectedLogLevels = [];
      } else {
        this.selectedLogLevels = LOG_LEVELS.slice();
      }
    });
  }

  get allesGeselecteerd(): boolean {
    return this.selectedLogLevels.length === LOG_LEVELS.length;
  }

  get ietsGeselecteerd(): boolean {
    return this.selectedLogLevels.length > 0 && !this.allesGeselecteerd;
  }

  get dropdownIcon(): string {
    if (this.allesGeselecteerd) {
      return 'mdi-close-box';
    }
    if (this.ietsGeselecteerd) {
      return 'mdi-minus-box';
    }
    return 'mdi-checkbox-blank-outline';
  }
}
